import { t } from "../../../services/utils";
import React from "react";
import { calculateTextHeight } from "../../../services/utils";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
class LineView extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        backgroundColor: "white",
        height: LineView.getHeight(this.props),
      },
      line: {
        fontSize: 16,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: this.props.paddingTop ? this.props.paddingTop : 0,
        paddingBottom: this.props.paddingBottom ? this.props.paddingBottom : 0,
      },
    };
    return (
      <div style={styles.container}>
        <div style={styles.line}>{this.props.line}</div>
      </div>
    );
  };
  static getHeight(props) {
    let height = 0;
    if (props.paddingTop) {
      height += props.paddingTop;
    }
    if (props.paddingBottom) {
      height += props.paddingBottom;
    }
    return (
      height +
      calculateTextHeight(props.line, STORY_VIEW_WIDTH - 20, {
        fontSize: 16,
      })
    );
  }
}
export default LineView;
